import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router';

import { type EasyBreadcrumbsItem } from './EasyBreadcrumbs.types';

type EasyBreadcrumbsProps = {
  readonly items: EasyBreadcrumbsItem[];
};

export const EasyBreadcrumbs = ({ items }: EasyBreadcrumbsProps) => {
  const firstPart = items.slice(0, -1);
  const lastItem = items[items.length - 1];

  return (
    <Breadcrumbs
      separator={
        <Typography variant="labelSmLight" sx={{ marginBottom: '-3px' }}>
          /
        </Typography>
      }
      aria-label="breadcrumb"
    >
      {firstPart.map((item) => (
        <Link key={item.label} to={item.href} style={{ textDecoration: 'none' }}>
          <Typography variant="labelSmLight">{item.label}</Typography>
        </Link>
      ))}
      <Typography variant="labelSm">{lastItem.label}</Typography>
    </Breadcrumbs>
  );
};
